import { logUsage } from 'owa-analytics';
import { FluidLoadSource, FluidLoadOwaScenario, FluidOwaSource } from 'owa-fluid-validations';
import * as trace from 'owa-trace';

export default function fluidComponentError(
    owaScenario: FluidLoadOwaScenario,
    owaSource: FluidOwaSource,
    source: FluidLoadSource,
    error: Error
) {
    logUsage(
        'FluidComponentError',
        {
            OwaScenario_1: owaScenario,
            ComponentSource_2: source,
            Error_3: error.name,
            OwaSource_4: owaSource,
        },
        { isCore: true }
    );

    if (error) {
        error.name = '[FluidComponentError] ' + error.name;
        trace.errorThatWillCauseAlert(error);
    }
}
